import { Button, CircularProgress, Grid, Typography } from "@mui/material";

interface Props {
  // The RTK Query mutation hook to upload the item
  uploadHook: Function;
  // The event handler associated with the form as a whole, typically defined in
  //   AddItemDialog or EditItemDialog; UploadButton will call the handler with a
  //   name/value pair to update the relevant form field after successful upload
  handler: (event: any) => void;
  // The form name UploadButton should populate with a URL on successful upload
  fieldToSet: string;
  // The item name to display on button
  itemName: string;
}

const UploadButton = ({ uploadHook, handler, fieldToSet, itemName }: Props) => {
  const [upload, { isLoading, isSuccess, isError }] = uploadHook();
  const handleUpload = async (event: any) => {
    const file = event.target.files[0];
    const formData = new FormData();
    formData.append("file", file);
    const response = await upload(formData);
    if ("data" in response) {
      const responseData = response.data;
      if ("downloadUrl" in responseData) {
        handler({
          target: {
            name: fieldToSet,
            value: responseData.downloadUrl,
          },
        });
      }
    }
  };
  return (
    <Grid container spacing={1} alignItems="center">
      <Grid item>
        <Button
          variant="contained"
          component="label"
          onChange={(event: React.FormEvent) => handleUpload(event)}
          disabled={isLoading || isSuccess}
        >
          Upload {itemName}
          <input type="file" hidden />
        </Button>
      </Grid>
      {isLoading && (
        <Grid item>
          <CircularProgress></CircularProgress>
        </Grid>
      )}
      {isSuccess && <Typography variant="body2">Upload successful.</Typography>}
      {isError && <Typography variant="body2">Upload failed.</Typography>}
    </Grid>
  );
};

export default UploadButton;
